import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=c4c8c9be&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4c8c9be')) {
      api.createRecord('c4c8c9be', component.options)
    } else {
      api.rerender('c4c8c9be', component.options)
    }
    module.hot.accept("./UserIcon.vue?vue&type=template&id=c4c8c9be&functional=true&", function () {
      api.rerender('c4c8c9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/icons/UserIcon.vue"
export default component.exports